<template>
  <div id="about-background">
    <div class='sequence about-background-title' transition='fromRight' >Female(She/Her) / Osakan from Japan / a wife / a mom of one daughter and a cat, living in Bedford-Stuyvasant Brooklyn, New York</div>
    <div class='sequence about-background-detail' transition='fromRight' >
      <p>
        I was born in Aichi Japan, spent most of my youth life in Osaka. 
        Osaka produces high quality self claim comedians. Osakans are famouse for 
        making fun of themselves.<br /> 
        Therefore, that's how I am.  
      </p>
    </div>
    <div class='sequence about-background-detail' transition='fromRight' >
      <p>
        My programming experience is at elementally school. A neighbor taught me 
        Apple programming language "Logo". 
      </p>
      <p>
        I moved to New York to study photo journalism. But at school, 
        I was taught computer programming by linux guru teacher and a Networking by Cisco system admin teacher, at 
        community college. After that I chagned major to computer science and 
        moved on to major Bachelor and Master Queens College at CUNY.    
      </p>
      <p>
        I love house music, surfing, and cats.
      </p>
      <p>
        I've been <a href="https://www.instagram.com/p/CEwpcMEnFD0/?igshid=1hi63iuiw0j51" target="_new"><span class="c-title">teaching programming language for local children</span></a>. I'm also looking for 
        opportunity to keep doing so. 
      </p>
    </div>

  </div>
</template>

<script>
  import gsap from "gsap";

  const currentTweens = [];
  const initSequence = [
    async function(){
      this.invalidatePreviousTransition();
      jQuery( ".sequence[transition='fromRight']" ).attr("style", "");
      const tw = await gsap
        .from(".sequence[transition='fromRight']", {
          duration: 1,
          x: 100,
          opacity: 0,
          ease: "power2.inOut",
          stagger: 0.3,
          clearProps: "transform,opacity"
        });
      currentTweens.push(tw);
    }
  ];

  const destroySequence = [
    async function(){
      this.invalidatePreviousTransition();
      const tw = await gsap
        .to(".sequence[transition='fromRight']", {
          duration: 1,
          opacity: 0,
          x: -100,
          ease: "power2.inOut",
          clearProps: "all"
        });
      currentTweens.push(tw);
    }
  ];


  export default {
    props: ['active'],
    mounted(){
      console.log('about me mounted');
    },
    methods: {
      activate(){
        const _initSequence = initSequence;
        this.runSyncFunction( _initSequence );
      },
      deactivate(){
        console.log('deactivate!');
        const _destroySequence = destroySequence;
        this.runSyncFunction( _destroySequence );
      },
      invalidatePreviousTransition(){
        while( currentTweens.length > 0  ) {
          const tw = currentTweens.splice(0,1)[0]
          tw.invalidate();
        }
      },
      runSyncFunction( funcs = [] ){
        if( funcs.length == 0 ) return;
        const f = funcs[0];
        return f.call(this);
      }
    },
    watch: {
      active: function(){
        if( this.active == true ) {
          this.activate();
        } else {
          this.deactivate();
        }

      }
    }
  }

</script>

     
<style lang="scss">
  #about-background{
    overflow-y:auto;
    overflow-x:hidden;
    box-sizing: border-box;
    position:absolute;
    top:0px;
    left:0px;
    width: 100%;
    height: 100%;
    padding: 1.5em;
    .sequence {
      opacity: 1;
      width: 50vw;
      left: 100%;
    }
    .about-background-title{
      font-size: 2em;
      font-style: italic;
    }
    .sequence.about-background-detail{
      font-size: 1em;
      margin-top: 2em;
      & > p{
        line-height: 1.5em;
      }
    }

  }
</style>